import { Car, CheckCircle, Wrench, Sparkles, Ban } from "lucide-react";

export const VEHICLE_STATUSES = ["available", "rented", "cleaning", "maintenance", "blocked"] as const;
export type VehicleStatus = (typeof VEHICLE_STATUSES)[number];

export const VEHICLE_CATEGORIES = ["economy", "compact", "midsize", "suv", "luxury", "van", "truck"] as const;
export type VehicleCategory = (typeof VEHICLE_CATEGORIES)[number];

export const vehicleCategoryLabels: Record<VehicleCategory, string> = {
  economy: "Economy",
  compact: "Compact",
  midsize: "Midsize",
  suv: "SUV",
  luxury: "Luxury",
  van: "Van",
  truck: "Truck",
};

export const vehicleStatusConfig: Record<VehicleStatus, { label: string; icon: typeof Car; color: string; bgColor: string }> = {
  available: { label: "Available", icon: CheckCircle, color: "text-emerald-600", bgColor: "bg-emerald-50" },
  rented: { label: "Rented", icon: Car, color: "text-blue-600", bgColor: "bg-blue-50" },
  cleaning: { label: "Cleaning", icon: Sparkles, color: "text-amber-600", bgColor: "bg-amber-50" },
  maintenance: { label: "Maintenance", icon: Wrench, color: "text-orange-600", bgColor: "bg-orange-50" },
  blocked: { label: "Blocked", icon: Ban, color: "text-red-600", bgColor: "bg-red-50" },
};

export interface VehicleData {
  id: string;
  vehicle_code: string | null;
  branch_id?: string | null;
  plate_number: string;
  make: string | null;
  model: string | null;
  year: number | null;
  category: VehicleCategory | null;
  color: string | null;
  mileage: number | null;
  daily_rate: number | null;
  status: VehicleStatus;
  insurance_expiry: string | null;
  image_url: string | null;
  notes: string | null;
  lube_change_interval_km: number | null;
  last_lube_change_km: number | null;
  last_lube_change_date: string | null;
  tire_change_interval_km: number | null;
  last_tire_change_km: number | null;
  last_tire_change_date: string | null;
  brake_service_interval_km: number | null;
  last_brake_service_km: number | null;
  last_brake_service_date: string | null;
  engine_check_interval_km: number | null;
  last_engine_check_km: number | null;
  last_engine_check_date: string | null;
}
